import style from "@/styles/pages/ConfirmApplication/ConfirmApplication.module.css";
import { RootState } from "@/store/dtm";
import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import { useEffect } from "react";
import { setApplicationEndpointReached } from "@/slices/applicationSlice";
import FadeTransition from "@/styles/animation/FadeTransition";
import { useNavigate } from "react-router-dom";
import { createApiClient } from "@/lib/Requests";
import { ApplicationDto } from "@/lib/DTMWebAPIClient.generated";
import { setClickInsightEvents, setSingleClickInsightEvent } from "@/lib/util";

export default function IDCheckFailed() {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const application = useSelector(
    (state: RootState) => state.application.application
  );
  const applicant = useSelector(
    (state: RootState) => state.applicant.applicant
  );
  const credential = useSelector((state: RootState) => state.credential);
  const referralProducts = useSelector((state: RootState) => state.referralProducts.products);
  const client = createApiClient({ timeout: 60000, token: credential.credential.accessToken });

  useEffect(() => {
    document.title = "Application Confirmation";
    setSingleClickInsightEvent("IDVerificationComplete", "fail")
    setClickInsightEvents(referralProducts, "applicationFailure", "main", "new", "auto-declined", application.id, applicant);

    if (application.applicationEndpointReached == false) {
      // set it to true, run script
      dispatch(setApplicationEndpointReached(true));
    }

    client.apiApplicationsFetch().then((result) => {
      result.application = application;
      result.applicant = applicant;
      client.apiApplicationsSave(new ApplicationDto({
        applicationData: JSON.stringify(result)
      })).catch((error) => {
        console.log("Error saving application info");
      });
    }).catch((error) => {
      console.log("Error fetching application info");
    });

  }, []);

  const handleClick = () => {
    navigate("/home", { replace: true });
  }

  return (
    <FadeTransition>
      <main aria-labelledby="main-content">
        <div className="main-container max-md:mt-10">
          <div className={style.contentContainer}>
            <div className="flex flex-col max-xs:px-3 max-md:items-center">
              <div className={style.emHeading}>
                <div className="grid grid-cols-1">
                  <h1>Your application was unsuccessful</h1>
                  <p>
                  Thank you for considering us. After careful review, we regret to inform you that your submission does not meet the criteria required to proceed with the application process.
                  </p>
                  <p>
                  If you have any questions, our Member Service Team can be reached at 1-866-592-2226.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="mb-5">
            <button
              type="submit"
              onClick={handleClick}
              style={{width: 165}}
              className={clsx("primary mt-5 w-full sm:w-28 h-11 px-6")}>
                Exit Application
            </button>
          </div>
        </div>
      </main>
    </FadeTransition>
  );
}